const VITE_APP_BACKEND_URL = import.meta.env.VITE_APP_BACKEND_URL;

const appConfig = {
  apiBaseUrl: () => VITE_APP_BACKEND_URL,
};

export default appConfig;
